import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'catalogos/configurador-nombramiento-usuario-notificar';

/**
 * GET Configuradores Nombramiento Usuario Notificar
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getConfiguradoresNombramientoUsuarioNotificar = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Configurador Nombramiento Usuario Notificar
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getConfiguradorNombramientoUsuarioNotificar = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Configurador Nombramiento Usuario Notificar
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postConfiguradorNombramientoUsuarioNotificar = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Configurador Nombramiento Usuario Notificar
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchConfiguradorNombramientoUsuarioNotificar = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Configurador Nombramiento Usuario Notificar
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteConfiguradorNombramientoUsuarioNotificar = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
